import React from "react";
import { useSettings } from "../contexts/SettingsContext";

export default function About() {
    const { settings } = useSettings();
    return (
        <div className="container-x py-10" data-testid="about-page">
            <div className="mb-10">
                <h1 className="font-heading text-5xl uppercase tracking-tighter font-bold">{settings.site_name || settings.company_name || "ccashop"}</h1>
                <p className="text-muted-foreground mt-3 max-w-3xl text-lg">{settings.company_tagline}</p>
            </div>
            <div className="prose prose-neutral max-w-3xl whitespace-pre-line text-muted-foreground leading-relaxed">
                {settings.about_us}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
                {[{ n: "10+", l: "Ani experiență" }, { n: "2000+", l: "Proiecte realizate" }, { n: "98%", l: "Clienți mulțumiți" }].map((s, i) => (
                    <div key={i} className="border-2 border-foreground p-8 text-center">
                        <div className="font-heading text-6xl font-bold text-primary">{s.n}</div>
                        <div className="font-mono text-xs uppercase tracking-widest mt-2">{s.l}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
